import { SearchOperators } from "../search-operators";
import { FilterBlock } from "../visual-filters";

export class ExternalMAMSearchRequest {
  constructor(
    public id: string,
    public filterBlocks: Array<FilterBlock> = [],
    public searchOperators: SearchOperators = new SearchOperators(),
  ) {}
}
